<template>
  <div class="market">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <BasicContainer>
        <div class="head" v-if="showNav">实时行情</div>
        <div class="banner">
          <img :src="require(`@/assets/market.png`)" alt="" />
        </div>
        <div class="main">
          <div class="title">
            <div class="word">实时行情</div>
            <div class="time">{{ time }}</div>
          </div>
          <MarketBox
            class="marketBox"
            :marketData="marketData"
            v-if="marketData.length !== 0"
            @setScroll="setScroll"
          ></MarketBox>
        </div>
      </BasicContainer>
    </van-pull-refresh>
  </div>
</template>

<script>
import MarketBox from "./marketBox";
import { getMarket } from "@/api/market";
import dateProcessing from "@/util/dateProcessing";
export default {
  components: { MarketBox },
  watch: {
    oldTime(newVal) {
      this.time = dateProcessing(new Date(newVal));
    },
  },
  data() {
    return {
      createTime: null,
      oldTime: null,
      time: "",
      marketData: [],
      isLoading: false,
      timer: null,
      gallery_scroll: 0,
      showNav: true,
    };
  },
  async created() {
    const url = window.location.href;
    if (url.indexOf("?") !== -1) {
      const showNav = decodeURIComponent(
        url.split("?")[1].split("&")[1].split("=")[1]
      );
      this.showNav = showNav == "false" ? false : true;
    }
    this.getData();
    this.$once("hook:beforeDestroy", () => {
      clearInterval(this.timer);
      this.timer = null;
    });
  },
  mounted() {
    window.onscroll = () => {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      this.gallery_scroll = scrollTop;
    };
  },
  activated() {
    const gallery_scroll = localStorage.getItem("gallery_scroll");
    document.body.scrollTop = gallery_scroll;
    document.documentElement.scrollTop = gallery_scroll;
  },
  methods: {
    async getData() {
      const result = await getMarket();
      this.marketData = result.data.data.metalPrices;
      this.createTime = Number(result.data.data.createTime);
      this.oldTime = this.createTime;
      this.timer = setInterval(() => {
        this.oldTime = this.oldTime + 1000;
      }, 1000);
    },
    onRefresh() {
      clearInterval(this.timer);
      this.timer = null;
      this.getData();
      this.isLoading = false;
    },
    setScroll() {
      localStorage.setItem("gallery_scroll", this.gallery_scroll);
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 88px;
  line-height: 88px;
  background: #fff;
  text-align: center;
  font-size: 36px;
  font-weight: bold;
}
.banner {
  width: 750px;
  height: 120px;
  margin-top: 20px;
  img {
    width: 100%;
    height: 100%;
  }
}
.main {
  width: 710px;
  min-height: 1329px;
  background: #fff;
  border-radius: 24px;
  margin: 0 auto;
  margin-top: 24px;
  .title {
    padding-top: 32px;
    margin: 0 auto;
    width: 646px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    .word {
      width: 150px;
      height: 40px;
      color: rgba(51, 51, 51, 1);
      font-size: 28px;
      line-height: 40px;
      font-weight: bold;
    }
    .time {
      width: 349px;
      height: 37px;
      line-height: 37px;
      color: rgba(51, 51, 51, 1);
      font-size: 26px;
      text-align: right;
    }
  }
  .marketBox {
    margin: 0 auto;
  }
}
</style>
